import React from 'react';
import t from 'prop-types';
import * as HERRAMIENTA from './constantes';
import BotonConBarraSecundaria from './boton-con-barra-secundaria';
import MuestraColor from './muestra-color';
import MuestraGrosor from './muestra-grosor';

function BotonGrosorColor(props) {
  function handleColorPresionado(herramientaId, grupo, valor) {
    onPresionado(herramientaId, grupo, valor);
  }

  function handleGrosorPresionado(herramientaId, grupo, valor) {
    onPresionado(herramientaId, grupo, valor);
  }

  var herramientaId = props.herramientaId,
      grupo = props.grupo,
      herramientaGrosorId = props.herramientaGrosorId,
      grosores = props.grosores,
      grosorSeleccionado = props.grosorSeleccionado,
      herramientaColorId = props.herramientaColorId,
      colores = props.colores,
      colorSeleccionado = props.colorSeleccionado,
      seleccionado = props.seleccionado,
      onPresionado = props.onPresionado;
  return React.createElement(BotonConBarraSecundaria, {
    herramientaId: herramientaId,
    grupo: grupo,
    seleccionado: seleccionado,
    onPresionado: onPresionado
  }, grosores && React.createElement(MuestraGrosor, {
    herramientaId: herramientaGrosorId,
    grupo: grupo,
    valores: grosores,
    valorSeleccionado: grosorSeleccionado,
    onPresionado: handleGrosorPresionado
  }), colores && React.createElement(MuestraColor, {
    herramientaId: herramientaColorId,
    grupo: grupo,
    valores: colores,
    valorSeleccionado: colorSeleccionado,
    onPresionado: handleColorPresionado
  }));
}

BotonGrosorColor.propTypes = process.env.NODE_ENV !== "production" ? {
  /** id de herramienta */
  herramientaId: t.string.isRequired,

  /** grupo de herramienta, por defecto: 'Pizarra' */
  grupo: t.string,

  /** id de herramienta de colores o false para no mostrar la barra de colores */
  herramientaColorId: t.string,

  /** 
   * Lista de colores.
   */
  colores: t.arrayOf(t.string),

  /** 
   * color inicialmente seleccionado, debe existir en la lista de colores,
   * por defecto, el primero de la lista
   * 
   * */
  colorSeleccionado: t.string,

  /** id de herramienta de grosores, o false para no mostrar la barra de grosores */
  herramientaGrosorId: t.string,

  /** 
   * Lista de grosores
   */
  grosores: t.arrayOf(t.number),

  /** 
   * grosor inicialmente seleccionado, debe existir en la lista de grosores,
   * por defecto, el primero de la lista
   */
  grosorSeleccionado: t.number,
  seleccionado: t.bool,
  onPresionado: t.func
} : {};
BotonGrosorColor.defaultProps = {
  grupo: HERRAMIENTA.GRUPO_PIZARRA
};
export default BotonGrosorColor;